import './contacts.css';

const Contacts = () => {
    return (
        <div className='Contacts'>
            <h3>Phone:</h3>
            <a href='tel:1 (800) 446 92 40'>1 (800) 446 92 40</a>

            <h3>Store address:</h3>
            <div>201 Fifth Ave</div>
            <div>Williamsburg, VA 23185</div>
        </div>
    )
}

export default Contacts;